import { MarketingMessage } from './MarketingMessage';
import icon_battery from '../../assets/icon_battery_empty_state.svg';

export const MarketingMessageBattery = () => {
  return (
    <MarketingMessage heading="Battery" icon={icon_battery} showContact={true}>
      <>
        <p>
          Many commercial customers have discovered the advantages of battery energy storage systems
          (BESS).
        </p>
        <p>
          Batteries can provide backup power, and can shift energy usage away from expensive time
          periods into times when electricity prices are much lower.{' '}
        </p>
        <p>
          Elexity has helped analyze BESS options for hundreds of commercial customers. Please
          contact us if you'd like a free analysis of how a BESS would perform at your facility.
        </p>
      </>
    </MarketingMessage>
  );
};
